import styled from "styled-components";
import {MainContainer} from "../../common/generic-react.styles.js";
export const MaintenanceMainContainer = styled(MainContainer).withConfig({
  displayName: "maintenancestyles__MaintenanceMainContainer",
  componentId: "sc-3exo4h-0"
})(["", " ", " padding:10% 0;"], {
  alignItems: "center",
  minHeight: "100%",
  height: "100%"
}, ({
  color = "#36475F"
}) => `background-color: ${color};`);
export const MaintenanceContainer = styled.div.withConfig({
  displayName: "maintenancestyles__MaintenanceContainer",
  componentId: "sc-3exo4h-1"
})(["", " padding:0 10%;flex:1;"], {
  "--tw-bg-opacity": "1",
  backgroundColor: "rgba(255, 255, 255, var(--tw-bg-opacity))",
  display: "flex",
  flexDirection: "column",
  width: "100%"
});
export const LogoContainer = styled.div.withConfig({
  displayName: "maintenancestyles__LogoContainer",
  componentId: "sc-3exo4h-2"
})(["", " max-height:20%;padding-top:60px;img{max-width:40%;width:auto;height:auto;}"], {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "flex-start"
});
export const ContentContainer = styled.div.withConfig({
  displayName: "maintenancestyles__ContentContainer",
  componentId: "sc-3exo4h-3"
})(["", " flex:1;"], {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  flexWrap: "wrap"
});
export const TextContainer = styled.div.withConfig({
  displayName: "maintenancestyles__TextContainer",
  componentId: "sc-3exo4h-4"
})(["", " padding-top:80px;"], {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  width: "50%"
});
export const TitleContainer = styled.div.withConfig({
  displayName: "maintenancestyles__TitleContainer",
  componentId: "sc-3exo4h-5"
})(["", " line-height:1.15em;"], {
  fontSize: "3rem",
  lineHeight: "1",
  marginBottom: "1.75rem",
  width: "91.666667%"
});
export const SubTitleContainer = styled.div.withConfig({
  displayName: "maintenancestyles__SubTitleContainer",
  componentId: "sc-3exo4h-6"
})(["", " width:65%;"], {
  fontSize: "1.125rem",
  lineHeight: "1.75rem"
});
export const ImageContainer = styled.div.withConfig({
  displayName: "maintenancestyles__ImageContainer",
  componentId: "sc-3exo4h-7"
})(["", " img{max-width:610px;max-height:460px;width:100%;height:auto;position:relative;bottom:-1px;}"], {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  width: "50%"
});
